module.exports = __webpack_public_path__ + "img/sergeant-reason-icon1.b9672905.png";